import { Helmet } from "react-helmet-async"
import "../components/Homepage/Homepage.css"

import Hero from "../components/Broker/Hero"
import Instructions from "../components/Broker/Instructions"

export default function Broker() {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Salusion Referral Program",
        "description": "Join Salusion's Referral Program and help companies enhance their employee benefits with our cost-effective HRAs. Refer a company and get rewarded for supporting better benefits.",
        "url": "https://salusion.com/referral-program", // Add the canonical URL for this page
        "mainEntity": {
            "@type": "Service", // The referral program is a service
            "name": "Salusion Referral Program",
            "description": "Refer a company to Salusion's HRA solutions and earn rewards for supporting better benefits.",
            "provider": { // The organization offering this service
                "@type": "Organization",
                "name": "Salusion, Inc.",
                "url": "https://salusion.com",
                "logo": "https://salusion.com/assets/icons/logos/favicons/mini-logo-152x152.png",
                "sameAs": [ // Add your social media profiles
                    "https://twitter.com/Salusion",
                    "https://linkedin.com/company/salusion-inc"
                ]
            },
            // The 'offers' property now correctly describes what the Service offers
            "offers": [
                {
                    "@type": "Offer",
                    "name": "Referral Reward",
                    "description": "Refer a company and earn up to $42 per participant.",
                    "price": "42.00",
                    "priceCurrency": "USD",
                    "priceSpecification": {
                        "@type": "PriceSpecification",
                        "maxPrice": "42.00",
                        "minPrice": "0.00" // Good practice to include if maxPrice is present
                    },
                    "url": "https://salusion.com/referral-program-signup", // Direct URL to join/learn more about the offer
                    "category": "Referral Program", // Optional: specify the category of the offer
                    "itemOffered": { // What is being offered
                        "@type": "Service",
                        "name": "Referral Program Participation"
                    }
                }
            ]
        }
    };
    return (
        <>
            <Helmet>
                <title>Insurance Brokers - Support Better Benefits and Get Rewarded</title>
                <meta name="title" content="Support Better Benefits and Get Rewarded | Salusion Broker Program" />
                <meta name="description" content="Join Salusion's Broker Program and help companies enhance their employee benefits with our cost-effective HRAs." />
                <meta name="keywords" content="Salusion, referral program, HRA, employee benefits, partner, rewards" />
                <link rel="canonical" href="https://salusion.com/broker-program" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@Salusion" />
                <meta name="twitter:title" content="Refer & Earn with Salusion's HRA Program!" />
                <meta name="twitter:description" content="Help companies offer cost-effective HRAs and earn up to $42 per participant. Join Salusion's Referral Program today!" />
                <meta name="twitter:image" content="https://salusion.com/assets/images/homepage/reimbursement.svg" />
                <meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, symbolizing a reward for referrals." />

                <meta property="og:title" content="Join Salusion's Referral Program - Earn Rewards for HRA Referrals" />
                <meta property="og:description" content="Help businesses enhance employee benefits with Salusion's cost-effective HRAs. Refer a company and earn up to $42 per participant." />
                <meta property="og:image" content="https://salusion.com/assets/images/homepage/reimbursement.svg" />
                <meta property="og:url" content="https://salusion.com/broker-program" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Salusion" />
                <script type="application/ld+json">{JSON.stringify(schema)}</script>

            </Helmet>

            <Hero />
            <Instructions />
        </>
    )
}
